import { ProjectRole } from '../models/membership.model';
import { USER_ROLE } from '../models/user-role.model';

export function canManageProject(profileRole: string | null, projectRole: ProjectRole | null): boolean {
  return profileRole === USER_ROLE.PLATFORM_ADMIN || projectRole === 'PROJECT_ADMIN';
}
